import { Instagram, Star, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-steel/60 bg-midnight/70 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <img
            src="/images/master-blaster-logo.png"
            alt="The Master Blaster logo"
            data-testid="footer-logo"
            className="w-64 sm:w-80"
          />
          <p className="mt-6 font-jbmono text-xs uppercase tracking-[0.25em] text-cream/50">
            One foot up. Sphincter down. America flows again.
          </p>
        </div>
        <div className="lg:col-span-3">
          <h4 className="font-jbmono text-xs uppercase tracking-[0.25em] text-crimson mb-6">Explore</h4>
          <ul className="space-y-3">
            {[
              { label: "The Science", href: "#science" },
              { label: "How It Works", href: "#how-it-works" },
              { label: "Pricing", href: "#pricing" },
            ].map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-cream/60 hover:text-gold transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <Link
                to="/admin"
                data-testid="footer-owner-login"
                className="flex items-center gap-1.5 text-sm text-cream/60 hover:text-gold transition-colors duration-200"
              >
                <Lock className="w-3.5 h-3.5" />
                Owner Dashboard
              </Link>
            </li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h4 className="font-jbmono text-xs uppercase tracking-[0.25em] text-crimson mb-6">Contact</h4>
          <a
            href="https://instagram.com/CrazyNeighborEdward"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-contact-link"
            className="inline-flex items-center gap-3 border border-steel hover:border-crimson rounded-sm px-5 py-3.5 transition-colors duration-200 group"
          >
            <Instagram className="w-5 h-5 text-crimson" />
            <span className="font-jbmono text-sm text-cream/80 group-hover:text-cream transition-colors duration-200">
              @CrazyNeighborEdward
            </span>
          </a>
          <p className="mt-4 text-xs text-cream/40 leading-relaxed">
            Questions, wholesale, testimonials of triumph — hit Edward on Instagram.
          </p>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-steel/40 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-cream/40">
          © 2026 Master Blaster. All rights reserved.
        </p>
        <p className="flex items-center gap-2 font-jbmono text-[10px] uppercase tracking-[0.25em] text-cream/40">
          <Star className="w-3 h-3 text-crimson fill-crimson" />
          Officially on sale Christmas Day
        </p>
      </div>
    </div>
  </footer>
);
